import React from "react";

const WidgetCatalogLoader = () => {
  return (
    <div className="widgetCatalogGrid">
      {Array.from({ length: 10 }).map((_, i) => (
        <div key={i} className="widgetCatalogCard">
          <div className="widgetCatalogCardTop">
            <span className="linear-background widgetCatalogSkeletonBadge" />
          </div>
          <span className="linear-background widgetCatalogSkeletonTitle" />
          <span className="linear-background widgetCatalogSkeletonBtn" />
        </div>
      ))}
    </div>
  )
}
export default WidgetCatalogLoader